import { useAvatarUserStyles } from "./avatar-user.styles";
import { Avatar, SkeletonAvatar } from "@/base/components/index";
import { UserIcon } from "@/base/static/icons/index";
import { AvatarUserProps } from "../types/index";
import { useEffect, useState, memo } from "react";
import { ProfileImageType } from "@/schemas/profile/profile-image";
import { useProfile } from "@/app/hook/use-profile";

export const AvatarUser = memo(({ login, size = 32 }: AvatarUserProps) => {
  const { styles } = useAvatarUserStyles();
  const { fetchAvatarByLogin } = useProfile();
  const [profileImage, setProfileImage] = useState<ProfileImageType>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      if (!login) {
        setProfileImage(undefined);
        setLoading(false);
        return;
      }

      fetchAvatarByLogin(login)
        .then((profileImage) => setProfileImage(profileImage || undefined))
        .catch(() => setProfileImage(undefined))
        .finally(() => setLoading(false));
    }, 600);

    return () => {
      clearTimeout(timer);
    };
  }, [login]);

  if (loading) {
    return <SkeletonAvatar className={styles.skeleton} size={size} active />;
  }

  return (
    <Avatar
      className={styles.root}
      size={size}
      icon={<UserIcon />}
      src={
        profileImage && (
          <img src={`data:image/jpeg;base64,${profileImage}`} alt="avatar" />
        )
      }
    />
  );
});
